var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifying-glass",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.435,
    height: 17.436,
    viewBox: "0 0 17.435 17.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M38.642,36.424l-3.112-3.1a.334.334,0,0,0-.051-.038,7.551,7.551,0,0,1-.991,1.216,7.418,7.418,0,0,1-1.221.992c.015.016.027.035.043.05l3.106,3.112a1.575,1.575,0,0,0,2.227-2.227Z",
    transform: "translate(-21.666 -21.675)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M12.378,2.12a7.253,7.253,0,1,0,0,10.258A7.26,7.26,0,0,0,12.378,2.12ZM3.454,11.046a5.369,5.369,0,1,1,7.592,0A5.375,5.375,0,0,1,3.454,11.046Z",
    transform: "translate(0 0)",
    fill: "#4397d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M11.182,20.068c-.154-.632-.787-1.509-1.32-1.229-.422.216-.3,1.2-.1,1.788.89,2.658,4.126,3.219,4.463,2.883S11.792,22.569,11.182,20.068Z",
    transform: "translate(-6.238 -12.235)",
    fill: "#4397d2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.dd81bf94dbd12ee2d96fac54da2996cc.svg";
export { ForwardRef as ReactComponent };